import React from 'react';
import { object, ref, string } from 'yup';
import {
  Formik,
  Form,
} from 'formik';
import axios from 'axios';

import FormGroup from '~/commons/components/FormGroup.jsx';
import { useAlert } from '../../../commons/components/alert/index.jsx';
import FormErrorAlert from '../../../admin/components/forms/FormErrorAlert.jsx';
import useQuery from '../../../commons/hooks/useQuery.js';

const FormSetPwd = ({ }) => {
  const { key } = useQuery();

  const showAlert = useAlert();

  return (
    <>
      <Formik
        validationSchema={object().shape({
          password: string().required().matches(
            /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
            'Password must at least 8 characters, one uppercase, one lowercase, one number',
          ),
          passwordConfirm: string().when('password', {
            is: (p) => p,
            then: (s) => s.required().oneOf([ref('password')], 'Password does not match'),
          }),
        })}
        initialValues={{
          password: '',
          passwordConfirm: '',
        }}
        validateOnMount={true}
        onSubmit={async ({ password }) => {
          try {

            const res = await axios.patch('/api/core/pwd-resets', {
              key,
              password,
            });

            if (res.status !== 200) {
              showAlert('danger', 'Unknown error', 2000);
              return;
            }

            const res2 = await axios.post('/api/core/auth', {
              username: res.data.email,
              password,
              web: 1,
            });
            if (res2.status === 200) {
              window.location.replace('/portal');
            } else {
              showAlert('danger', 'Unknown error', 2000);
            }

          } catch (e) {
            if (e.response?.status === 400) {
              showAlert('danger', e.response.data, 2000);
            } else {
              showAlert('danger', e, 2000);
            }
          }
        }}
      >
        {(props) => (
          <Form>
            <FormErrorAlert {...props} />
            <h2>Please set a password for your account</h2>
            <FormGroup
              name="password"
              type="password"
              label="Create your password *"
            />
            <FormGroup
              name="passwordConfirm"
              type="password"
              label="Confirm your password *"
            />
            <div className="form-group text-right">
              <button className="btn btn-primary btn-block">
                Next
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default FormSetPwd;
